module.exports = __webpack_public_path__ + "img/annual_graphics.7c1f750b.png";